module.exports = __webpack_public_path__ + "static/media/av-logo_kp.5f52ff0b.svg";